// Small Ledger affiliate banner — slotted in /shadow sidebar below RankingWidget.
import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { i18nLedger, pickLang } from "../i18n/ledger-affiliate";

const LedgerShadowBanner = () => {
  const { lang } = useLanguage();
  const L = ["es", "en", "sk", "de", "zh-CN"].includes(lang) ? lang : "en";
  const t = (k) => pickLang(i18nLedger[k], L);
  return (
    <div
      data-testid="ledger-shadow-banner"
      style={{
        background: "rgba(0,212,255,.04)",
        border: "1px solid rgba(0,212,255,.12)",
        borderRadius: 8,
        padding: "12px 14px",
      }}
    >
      <div
        style={{
          fontSize: 10,
          color: "rgba(255,255,255,.45)",
          letterSpacing: ".15em",
          marginBottom: 6,
          fontWeight: 700,
        }}
      >
        {t("shadowEyebrow")}
      </div>
      <div style={{ fontSize: 12, color: "rgba(255,255,255,.7)", marginBottom: 8 }}>
        {t("shadowCopy")}
      </div>
      <a
        href="https://shop.ledger.com/?r=eb740c0da9e0&tracker=shadow_network"
        target="_blank"
        rel="noopener noreferrer sponsored"
        data-testid="ledger-shadow-banner-link"
        style={{
          display: "block",
          textAlign: "center",
          background: "rgba(0,212,255,.1)",
          border: "1px solid rgba(0,212,255,.3)",
          color: "#00d4ff",
          fontSize: 11,
          fontWeight: 700,
          padding: "7px 12px",
          borderRadius: 6,
          textDecoration: "none",
          letterSpacing: ".05em",
        }}
      >
        {t("shadowCta")}
      </a>
      <p
        style={{
          fontSize: 9,
          color: "rgba(255,255,255,.25)",
          textAlign: "center",
          margin: "6px 0 0",
        }}
      >
        {t("shadowAviso")}
      </p>
    </div>
  );
};

export default LedgerShadowBanner;
